import React, { useEffect } from "react";
import { getLab, resetLaboratorioFlag } from "../../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Alert,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import EditarLaboratorio from "./EditarLaboratorio";
import { DatosSesion } from "../../../Components/Common/DatosSesion";
 
const LaboratorioEditar = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const perfil = DatosSesion("perfil");
  
  useEffect(() => {
    dispatch(getLab(id));
  }, [dispatch, id]);

  const selectLayoutState = (state) => state;
  const laboratorioPageData = createSelector(selectLayoutState, (state) => ({
    laboratorio: state.Laboratorios.laboratorio,
    error: state.Laboratorios.error,
    loading: state.Laboratorios.loading,
    errorMsg: state.Laboratorios.errorMsg,
    colorMsg: state.Laboratorios.colorMsg,
    exito: state.Laboratorios.exito,
  }));

  const { laboratorio, exito, error, loading, errorMsg, colorMsg } =
    useSelector(laboratorioPageData);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLaboratorioFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);
 
  return ( 
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <>
              <BreadCrumb
                title="Editar Laboratorio"
                pageTitle="Listar Laboratorio"
                url="/laboratorios"
              />

              <Row>
                <Col lg={12}>
                  <Card>
                    <CardHeader className="border-0">
                      {errorMsg && errorMsg ? (
                        <Alert color={colorMsg}> {error} </Alert>
                      ) : null}
                    </CardHeader>
                    <CardBody>
                      {exito && <EditarLaboratorio laboratorio={laboratorio} />}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LaboratorioEditar;
